import { GET_FAQ,  GET_FAQ_SUCCESS, GET_FAQ_FAILURE, RESET_FAQ, FaqState, FaqActionTypes } from "../types/faqTypes";


const initialState: FaqState = {
    faqSuccess: null,
    faqList: [],
    faqError: null,
    faqLoading: false,
};

export const faqReducer = (state = initialState, action: FaqActionTypes): FaqState => {
    switch (action.type) {
        case GET_FAQ: {
            return { ...state, faqList: [], faqError: null, faqLoading: false };
        }

        case GET_FAQ_SUCCESS: {
            return { ...state, faqSuccess: action.payload?.message, faqList: action.payload?.data, faqError: null, faqLoading: false };
        }

        case GET_FAQ_FAILURE: {
            return { ...state, faqError: action.payload, faqList: null, faqLoading: false };
        }

        case RESET_FAQ: {
            return { ...state, faqSuccess: null, faqError: null, faqLoading: false };
        }

        default:
            return state;
    }
};
